import React from 'react';
import withIcon from '../utilities/withIcon';

const IconFolder = () => {
  return (
    <g>
      <path d="m1.05 1.001 4.743.016c.396.001.754.224.931.57l.052.12.84 2.301 7.335.01c.541 0 .986.41 1.043.935l.006.114v8.883c0 .541-.41.987-.936 1.044L14.95 15H1.05a1.05 1.05 0 0 1-1.044-.936L0 13.95v-8.9c0-.104.015-.206.044-.301H0V2.051c0-.45.284-.84.76-1l.135-.037L1.05 1zm.45 4.5V13.5h13V5.516l-13-.015zm0-2.999-.001 1.499 4.518.005-.543-1.491L1.5 2.502z" />
    </g>
  );
};

export default withIcon(IconFolder);
